import Swal from 'sweetalert2';

$('#modal-request-form').asyncForm(e => {
    if (e) {
        return Swal.fire({
            title: "Anfrage konnte nicht gesendet werden.",
            text: e,
            icon: "warning",
            showCancelButton: false
        });
    }
    Swal.fire({
        text: "Anfrage gesendet!",
        icon: "success",
        showCancelButton: false,
        onClose: () => $('#modal-request').modal('hide')
    });
});

$('#modal-offer-form').asyncForm(e => {
    if (e) {
        return Swal.fire({
            title: "Angebot konnte nicht gesendet werden.",
            text: e,
            icon: "warning",
            showCancelButton: false
        });
    }
    Swal.fire({
        text: "Angebot gesendet!",
        icon: "success",
        showCancelButton: false,
        onClose: () => $('#modal-offer').modal('hide')
    });
});

$('#modal-inquiry-form').asyncForm(e => {
    if (e) {
        return Swal.fire({
            title: "Gesuch konnte nicht gesendet werden.",
            text: e,
            icon: "warning",
            showCancelButton: false
        });
    }
    Swal.fire({
        text: "Gesuch gesendet!",
        icon: "success",
        showCancelButton: false,
        onClose: () => $('#modal-inquiry').modal('hide')
    });
});

$('#footer-contact-form').asyncForm(e => {
    if (e) {
        return Swal.fire({
            title: "Nachricht konnte nicht gesendet werden.",
            text: e,
            icon: "warning",
            showCancelButton: false
        });
    }
    Swal.fire({
        text: "Nachricht gesendet!",
        icon: "success",
        showCancelButton: false,
        onClose: () => $('#modal-contact').modal('hide')
    });
});